// extracted by mini-css-extract-plugin
export default {"root":"classes_root__fLDuu","backdrop":"classes_backdrop__a2nlT","modal":"classes_modal__ueQcu","fullwidth":"classes_fullwidth__Tmks0","fullscreen":"classes_fullscreen__IjRVj"};